import { useQuery, useZero } from "@rocicorp/zero/react";
import { useState } from "react";
import { generateId } from "../../shared/id";
import { sharedMutators } from "../../shared/mutators";
import { queries } from "../../shared/queries";
import { useToast } from "../components/Toast";

export function usePushLiveRequest(
  branch: { id: string; headCommitId: string | null } | undefined
) {
  const z = useZero();
  const { showToast } = useToast();
  const [submitting, setSubmitting] = useState(false);
  const [stored] = useQuery(
    queries.pushLiveRequestForBranch({ branchId: branch?.id ?? "" }),
    { enabled: branch !== undefined }
  );
  const request =
    branch && stored?.commitId === branch.headCommitId ? stored : undefined;

  const submit = async (reviewerIds: string[]) => {
    if (!branch) return;
    setSubmitting(true);
    try {
      const result = await z.mutate(
        sharedMutators.requestPushLive({
          id: generateId(),
          branchId: branch.id,
          reviewId: generateId(),
          reviewerIds,
        })
      ).server;
      if (result.type === "error") {
        showToast({
          icon: "circle-off",
          message: result.error.message,
          buttonLabel: "Dismiss",
        });
      }
    } catch {
      showToast({
        icon: "circle-off",
        message: "Couldn’t send the push request. Try again.",
        buttonLabel: "Dismiss",
      });
    }
    setSubmitting(false);
  };

  const cancel = () => {
    if (!request) return;
    z.mutate(sharedMutators.cancelPushLiveRequest({ requestId: request.id }));
  };

  const approve = async () => {
    if (!request) return;
    const result = await z.mutate(
      sharedMutators.approvePushLiveRequest({ requestId: request.id })
    ).server;
    if (result.type === "error") {
      showToast({
        icon: "circle-off",
        message: result.error.message,
        buttonLabel: "Dismiss",
      });
    }
  };

  return { request, submitting, submit, cancel, approve };
}
